export const ACTION_LOGOUT = 'logout';
export const ACTION_REHYDRATE_USER = 'rehydrate_user';
